<template>
  <div id="content">
    <topheader></topheader>
    <mobile-summary-widget :info="summaryInfo" :promo-code="promoCode" @save:promo_code="$emit('save:promo_code')"
      @remove:promo_code="$emit('remove:promo_code')" @update:promo_code="$emit('update:promo_code', $event)">
      <template v-slot:additional-section>
        <recurrence-discount-progress-bar :labelText="progressRecurrenceText" progressMargingClass="mb-2 mx-3"
          progressPaddingClass="px-3" :progressValue="progressRecurrenceValue" :progressValueMax="100"
          progressBarColor="success" labelTextMin="" labelTextMax="" />
      </template>
    </mobile-summary-widget>
    <div class="container-fluid px-md-5">
      <div class="row d-flex justify-content-center">
        <div class="content-wrapper booking-main-content mx-3">
          <step-indicator />
          <div class="form-wrapper">
            <div v-if="showPrevArrow" @click="toPrevStep" class="prev-button">
              <i class="fas fa-angle-left fa-3x"></i>
            </div>

            <cleaning-categories @update="onUpdate" :categories="categories" :selected="selectedCategory" :loading="loading"></cleaning-categories>

            <div class="col-12" v-show="selectedCategory">
              <included-services :services="summaryInfo.services" :selected-category-name="selectedCategoryName" :category-key="selectedCategory"></included-services>
            </div>

            <form @submit.prevent="onSubmit" class="pb-xs-5">
              <has-schedule-warning v-if="hasSchedule"></has-schedule-warning>
              <select-plan v-else
                @tier:picked="onTierPicked"
                :selected-tier="selectedTier"
                :tiers="tiers"
                :price-cents="summaryInfo.priceCents"
                title="Subscribe & Save"
              ></select-plan>
              <ask-terms />
              <button type="submit" class="btn btn-primary main-btn">Next</button>
            </form>
          </div>
        </div>
        <div class="content-wrapper booking-secondary-content d-none d-md-block full-height">
          <desktop-summary-widget :info="summaryInfo" :promo-code="promoCode"
            @save:promo_code="$emit('save:promo_code')" @update:promo_code="$emit('update:promo_code', $event)"
            @remove:promo_code="$emit('remove:promo_code')">
            <template v-slot:additional-section="{progressBarText, progressBarValue, progressBarMax}">
              <div class="pt-4 pb-2">
                <recurrence-discount-progress-bar :labelText="progressBarText" progressMargingClass="mb-2 mx-3"
                  progressPaddingClass="px-3" :progressValue="progressBarValue" :progressValueMax="progressBarMax"
                  progressBarColor="success" labelTextMin="" labelTextMax=""></recurrence-discount-progress-bar>
              </div>
            </template>
          </desktop-summary-widget>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import AskTerms from '../ask_terms.vue'
import StandardCleaningCard from '../booking/standard_cleaning_card.vue'
import UpkeepCleaningCard from '../booking/upkeep_cleaning_card.vue'
import MoveInOutCleaningCard from '../booking/move_in_out_cleaning_card.vue'
import SelectPlan from '../booking/select_plan.vue'
import HasScheduleWarning from '../booking/has_schedule_warning.vue'
import CleaningCategories from '../booking/cleaning_categories.vue'
import includedServices from '../booking/included_services.vue'
import RecurrenceDiscountProgressBar from '../booking/summary_widget/discount_progress_bar.vue'

import sharedApi from '@/shared/api'

export default {
  components: {
    AskTerms,
    StandardCleaningCard,
    UpkeepCleaningCard,
    MoveInOutCleaningCard,
    SelectPlan,
    HasScheduleWarning,
    CleaningCategories,
    includedServices,
    RecurrenceDiscountProgressBar
  },
  data() {
    return {
      progressRecurrenceValue: 10,
      progressRecurrenceText: 'Select recurrence to save [20%] off',
      categories: {},
      loading: false
    }
  },
  computed: {
    showPrevArrow() {
      return this.newProperty
    },
    selectedCategoryName() {
      let name = ''
      if (this.selectedCategory && this.categories) {
        name += this.categories[this.selectedCategory].name + " "
      }
      return name + 'cleaning'
    },
    ...mapGetters(['summaryInfo']),
    ...mapGetters({
      selectedCategory: 'reservation/cleaningCategory',
      frequency: 'reservation/frequency',
      promoCode: 'reservation/promo_code',
      header: 'property/plan_selection_header',
      newProperty: 'property/newProperty',
      tiers: 'property/tiers',
      selectedTier: 'selectedTier',
      hasSchedule: 'property/hasSchedule',
      termsAccepted: 'client/termsAccepted'
    }),
  },
  methods: {
    onTierPicked(tierKey) {
      if (tierKey == "standard") {
        this.$store.commit('reservation/SET_FREQUENCY', null)
        this.$store.commit('SET_TIER', tierKey)
        return;
      }

      const tier = this.tiers[tierKey]

      if (this.frequency == tier.frequency) {
        this.$store.commit('reservation/SET_FREQUENCY', null)
        this.$store.commit('SET_TIER', null)
      } else {
        this.$store.commit('reservation/SET_FREQUENCY', tier.frequency)
        this.$store.commit('SET_TIER', tierKey)
      }
    },
    onUpdate({ attr, value }) {
      if (attr == "category") {
        this.$store.dispatch("reservation/setCleaningCategory", value)
      }
    },
    onSubmit() {
      if (this.termsAccepted) {
        this.$store.dispatch('toExtras')
      } else {
        this.$flasher.error('You need to accept the terms and conditions')
      }
    },
    toPrevStep() {
      this.$store.dispatch('toSignUp', null, { root: true })
    },
    getCategories() {
      this.loading = true
      sharedApi.getCleannigCategories().then(response => {
        this.categories = response.data
        this.loading = false
      })
    },
    ...mapActions(['resumeBooking']),
  },
  mounted() {
    document.getElementsByTagName('body')[0].className = 'booking-bg'
    if (this.$store.getters['client/isDisabled']) {
      this.$flasher.error('You need to add a valid payment method to be able to book')
      this.$store.dispatch('toBilling')
      return
    }
    this.getCategories()
    this.$store.commit('STOP_INDICATOR')
  }
}
</script>
